import React, { useEffect, useState } from "react";
import Profile from "scenes/profile";
import {
    Box,
    Card,
    CardActions,
    CardContent,
    Collapse,
    Button,
    Typography,
    Rating,
    useTheme,
    useMediaQuery,
    Grid,
} from "@mui/material";
import {
    useGetStudentsQuery,
    useGetSchoolDashboardQuery,
    useGetSchoolDetailQuery,
    useGetSchoolTestDataMutation,
    useRecalculateScoresMutation,
} from "state/api";
import Header from "components/Header";
import { useSelector } from "react-redux";
import { RootState } from "state";
import SchoolDashboardSummary from "components/SchoolDashboardSummary";
import StudentsGrid from "components/StudentsGrid";
import FlexBetween from "components/FlexBetween";

import { dashboardConfig } from "config";

const Dashboard = () => {
    const [skip, setSkip] = useState(true);
    const { user } = useSelector((state: RootState) => state.auth);
    const { schoolId, schoolName } = useSelector(
        (state: RootState) => state.admin
    );
    const [id, setId] = useState(0);
    const [name, setName] = useState("");

    useEffect(() => {
        if (user && user.isAdmin && schoolId > 0) {
            console.log("School Id: ", schoolId);
            setSkip(false);
            setId(schoolId);
            if (schoolName) {
                setName(schoolName);
            }
        }
        if (user && user.school_id > 0) {
            setSkip(false);
            setId(user.school_id);
            if (user.school_name) {
                setName(user.school_name);
            }
        }
    }, [schoolId, schoolName, user]);

    const { data: schoolDetailData, isLoading: isSchoolDetailDataLoading } =
        useGetSchoolDetailQuery(Number(schoolId > 0 ? schoolId : user?.school_id), {
            skip,
        });
    const { data: studentsData, isLoading: isStudentsDataLoading } =
        useGetStudentsQuery(Number(schoolId > 0 ? schoolId : user?.school_id), {
            skip,
        });
    const { data: schoolData, isLoading: isDashboardDataLoading } =
        useGetSchoolDashboardQuery(
            Number(schoolId > 0 ? schoolId : user?.school_id),
            { skip: skip }
        );
    const isNonMobile = useMediaQuery("(min-width: 600px)");
    const theme = useTheme();

    const [generateSchoolTestData, { isLoading: isSchoolTestDataLoading }] =
        useGetSchoolTestDataMutation();

    const [recalculateScores, { isLoading: isRecalculateScoresLoading }] =
        useRecalculateScoresMutation();

    const getSchoolTestData = async () => {
        console.log("School Id: ", schoolId);
        if (schoolId <= 0) {
            alert("Something went wrong. Please try again later.");
        }

        try {
            const response = await generateSchoolTestData(schoolId).unwrap();

            const blob = new Blob([response], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = `${schoolName}-TestData.xlsx`;
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error("Error fetching school test data", error);
        }
    };

    const handleRecalculateScores = async () => {
        if (schoolId <= 0) {
            alert("Something went wrong. Please try again later.");
        }
        try {
            await recalculateScores(schoolId).unwrap();
            alert("Scores recalculated successfully");
        } catch (error) {
            console.error("Error recalculating scores", error);
            alert("Error recalculating scores");
        }
    };

    return (
        <Box m="1.5rem 2.5rem">
            <Header
                title={
                    schoolName && schoolName !== "" ? schoolName : user?.school_name || ""
                }
                subtitle={dashboardConfig.subtitle ?? ""}
            />
            {schoolDetailData || !isSchoolDetailDataLoading ? (
                <Box sx={{ flexGrow: 1, padding: 2 }}>
                    <SchoolDashboardSummary {...schoolDetailData?.aggregateData} />
                </Box>
            ) : (
                <>Loading...</>
            )}
            {user?.isAdmin && (
                <>
                    <FlexBetween style={{ marginTop: "1rem" }}>
                        <Button
                            onClick={getSchoolTestData}
                            disabled={false}
                            sx={{ color: theme.palette.secondary[600] }}
                        >
                            Download Test Data
                        </Button>
                    </FlexBetween>
                    <FlexBetween style={{ marginTop: "1rem" }}>
                        <Button
                            onClick={handleRecalculateScores}
                            disabled={false}
                            sx={{ color: theme.palette.secondary[600] }}
                        >
                            Recalculate Score
                        </Button>
                    </FlexBetween>
                </>
            )}
            {/*<StudentsGrid*/}
            {/*    data={studentsData}*/}
            {/*    isLoading={isStudentsDataLoading}*/}
            {/*    displayHeader={true}*/}
            {/*/>*/}
        </Box>
        // <div>
        //   <Profile />
        // </div>
    );
};

export default Dashboard;
